import { useEffect, useRef } from "react";
import styles from "./selectService.module.css";
import { useBodyScrollLock } from "../../../../utils/utils";
import { AMEND_SERVICE, OTHER_SERVICES, VOLTE } from "../../../../utils/constants/serviceConstants";
import { Action, Resource } from "../../../../casl/constants";
import CAN from '../../../../casl/can';
import SectionGuard from "../../../../hoc/guards/SectionGuard";
import { USER_TYPE } from "../../../../utils/constants/userConstants";
import IMAGES from "../../../../assets/images/images";


const SelectService = ({ isOpen,onClose, onSelect,isInternalUser }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const onKeyDown = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  useBodyScrollLock(isOpen)
  useEffect(() => {
    dialogRef.current?.focus();
  }, []);

  const onBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      className={styles.backdrop}
      onClick={onBackdropClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="selectServiceTitle"
      ref={dialogRef}
      tabIndex={-1}
    >
      <div className={styles.wrapper}>
        <div className={styles.headerwrapper}>
        <div className={styles.header}>
            <div className={styles.headertext}>
                <div id="selectServiceTitle" className={styles.title}>Which type of service do you wish to provision?</div>
            </div>
            <button className={styles.closeBtn} onClick={onClose} aria-label="Close">✕</button>
        </div>
        <div className={styles.subtitle}>Select a service category to continue.</div>
        </div>
        <div className={styles.body}>
          <div
            className={styles.card}
            onClick={() => onSelect?.(VOLTE)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onSelect?.(VOLTE)}
          >
            <div className={`${styles.sectionTitledes} ${styles.sectionTitle}`}><img className={styles.icondestination} src={IMAGES.iconhover} alt="icon"/></div>
            <div className={styles.service}><span className={styles.servicetypedes}>Destination Opening</span></div>
            <div className={styles.cardDesc}>Open new VoLTE roaming destinations with partner operators.</div>
          </div>

          <div
            className={styles.card}
            onClick={() => onSelect?.(OTHER_SERVICES)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onSelect?.(OTHER_SERVICES)}
          >
            <div className={`${styles.sectionTitle} ${styles.sectiontitle}`}>IPX Services</div>
            <div className={styles.service}><span className={styles.servicetype}>TRANSPORT</span><span className={styles.servicetype}>SIGTRAN</span><span className={styles.servicetype}>DIAMETER</span><span className={styles.servicetype}>DNS</span><span className={styles.servicetype}>HTTP2</span></div>
            <div className={styles.cardDesc}>Configure IPX interconnection and supporting services.</div>
          </div>
          {/* <SectionGuard canAccess={CAN(Action.LIST,Resource.LIVE_SERVICES) && CAN(Action.CREATE,Resource.DEMANDS) && !isInternalUser}>
          <div
            className={styles.card}
            onClick={() => onSelect?.(AMEND_SERVICE)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onSelect?.(AMEND_SERVICE)}
          >
            <div className={styles.cardTitle}>Amend Service</div>
            <div className={styles.service}><span className={styles.servicetype}>DIAMETER</span><span className={styles.servicetype}>DNS</span><span className={styles.servicetype}>SIGTRAN</span><span className={styles.servicetype}>TRANSPORT</span></div>
            <div className={styles.cardDesc}></div>
          </div>
          </SectionGuard> */}
        </div>
      </div>
    </div>
  );
};
export default SelectService
